import styled from '@emotion/styled';
import { HeaderNavBarHeight } from 'constants/layout';
import { ZIndex } from 'constants/zIndex';
import React, { ReactNode } from 'react';
import { MoreMenu } from 'ui-components/common/MoreMenu';
import { MenuItem } from 'ui-components/common/MoreMenuList';
import { css } from '@emotion/react';

export interface HeaderNavigationBarProps {
  leftButtons?: ReactNode[];
  rightButtons?: ReactNode[];
  hiddenMenu?: MenuItem[];
  className?: string;
  children?: ReactNode;
}

export const EpisodeViewerHeaderTitle = ({
  leftButtons,
  rightButtons,
  hiddenMenu,
  className,
  children,
}: HeaderNavigationBarProps) => (
  <StyledContainer className={className}>
    {leftButtons && <StyledLeftButtonList>{leftButtons}</StyledLeftButtonList>}
    <StyledChildren buttonsCount={2}>{children}</StyledChildren>
    <StyledBlock />
    {rightButtons && <StyledRightButtonList>{rightButtons}</StyledRightButtonList>}
    {hiddenMenu && hiddenMenu.length > 0 && <StyledMoreMenu menu={hiddenMenu} vertical />}
  </StyledContainer>
);

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${HeaderNavBarHeight}px;
  display: flex;
  align-items: center;

  z-index: ${ZIndex.NavBar};
`;

const StyledBlock = styled.div`
  width: 100%;
`;

const StyledChildren = styled.div(
  ({ buttonsCount }: { buttonsCount: number }) => css`
    display: flex;
    height: 100%;
    width: 100%;
    padding: 0 ${buttonsCount * 30 + 6}px 0 ${buttonsCount * 30 + 6}px;
    z-index: ${ZIndex.ViewerNavBar};

    left: 0;
    top: 0;
    position: absolute;
  `,
);

const StyledButtonList = styled.section`
  display: flex;
  justify-self: flex-start;
  align-items: center;

  gap: 16px;
`;

const StyledLeftButtonList = styled(StyledButtonList)`
  & > button:last-of-type {
    margin-right: 8px;
  }
`;

const StyledRightButtonList = styled(StyledButtonList)`
  & > button:first-of-type {
    margin-left: 8px;
  }
`;

const StyledMoreMenu = styled(MoreMenu)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-left: 16px;
`;
